import { render } from "./TheDarkModeToggle.vue?vue&type=template&id=4ccdd79d&scoped=true"
import script from "./TheDarkModeToggle.vue?vue&type=script&lang=js"
export * from "./TheDarkModeToggle.vue?vue&type=script&lang=js"

import "./TheDarkModeToggle.vue?vue&type=style&index=0&id=4ccdd79d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ccdd79d"]])

export default __exports__